import React from "react";
import { SvgIcon } from "@material-ui/core";

const TieIcon = props => {
  return (
    <SvgIcon {...props} viewBox="0 0 17.614 38.309">
      <path
        id="Path_2516"
        data-name="Path 2516"
        d="M39.8,33.125,35.839,52.1l5.634,7.045L47.107,52.1,43.146,33.125ZM45.135,52.41l-3.39,4.24-.543-.434,3.39-4.24Z"
        transform="translate(-32.665 -20.84)"
      />
      <path
        id="Path_2517"
        data-name="Path 2517"
        d="M40.007,15.27,37.1,18.408l3.271,4.439h3.56L47.2,18.408,44.29,15.27Z"
        transform="translate(-33.341 -11.258)"
      />
      <path
        id="Path_2518"
        data-name="Path 2518"
        d="M54.967,10.77l1.782,1.922L60.547,9l-3.2-2.391Z"
        transform="translate(-42.933 -6.607)"
      />
      <path
        id="Path_2519"
        data-name="Path 2519"
        d="M28.989,9l3.8,3.693,1.782-1.922-2.38-4.162Z"
        transform="translate(-28.989 -6.607)"
      />
    </SvgIcon>
  );
};

export default TieIcon;
